// Exports
export default {
	"stubWrapper": "stubWrapper_bi3Co"
};
